
import React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface NewArticleButtonProps {
  isJournalist: boolean;
  className?: string;
}

const NewArticleButton = ({ isJournalist, className }: NewArticleButtonProps) => {
  if (!isJournalist) return null;
  
  return (
    <Button asChild size="sm" className={className || "hidden md:flex"}>
      <Link to="/dashboard/editor/new">
        <Plus size={16} />
        <span>New Article</span>
      </Link>
    </Button>
  );
};

export default NewArticleButton;
